import type { Location } from 'react-router-dom';

export default function getQueryParameters(location: Pick<Location, 'search'>) {
  const query = new URLSearchParams(location.search);

  const queryParams = Array.from(query.entries()).reduce(
    (acc, [key, value]) => {
      acc[key] = value;
      return acc;
    },
    {} as Record<string, string>,
  );

  return queryParams;
}
